import { render } from "./RegisterAirport.vue?vue&type=template&id=6fa0c37c&scoped=true"
import script from "./RegisterAirport.vue?vue&type=script&lang=js"
export * from "./RegisterAirport.vue?vue&type=script&lang=js"

import "./RegisterAirport.vue?vue&type=style&index=0&id=6fa0c37c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa0c37c"]])

export default __exports__